// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UserEventsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UserEventsIcon" ref={forwardedRef} {...props}>
      <path d="M10.888.996v2.502h1.494V.996z" />
      <path d="M8.253 5.766 6.488 4l1.057-1.057L9.309 4.71z" />
      <path d="m4.98 13.06-2.37 2.38 1.408 1.415 2.38-2.39 1.887 4.03 4.81-12.149L1 11.18zm3.19 1.665-1.093-2.333-2.322-1.098 5.67-2.265z" />
      <path d="M16.01 7.147h2.49v1.501h-2.49z" />
      <path d="M15.995 2.588 14.23 4.353l1.057 1.057 1.764-1.765z" />
      <path d="m14.761 10.195 1.765 1.765-1.057 1.057-1.764-1.765z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UserEventsIcon = /* @__PURE__ */ Object.assign(
  UserEventsIconComponent,
  { displayName: 'UserEventsIcon' },
);
